import React from "react";
import LecturerNav from "../../navigation/LecturerNav";
import { Link } from "react-router-dom";

/**
 * This page presents the lecturer with a form that is populated with 4 different buttons.
 * When a button is pressed it will then redirect the user to the corresponding page that is linked to that button.
 * @returns a form with 4 buttons
 */

function LecturerHomepage() {
    return(
        <div className="studentHomepageContainer">
            <LecturerNav/>
            <form>
                <h1 style={{textAlign: "center"}}>Home Page</h1>
                <div className="buttonGridLec paper">
                    <Link to="/lecturerCreateEditProject">
                        <button className="homeButton" type="button">
                            Create/Edit Own Project
                        </button>
                    </Link>
                    <Link to="/lecturerViewProjects">
                        <button className="homeButton" type="button">
                            Project Suggestions
                        </button>
                    </Link>
                    <Link to="/lecturerEditInfo">
                        <button className="homeButton" type="button">
                            Edit Information
                        </button>
                    </Link>
                    <Link to="/lecturerViewFinalAllocation">
                        <button className="homeButton" type="button">
                            Final Project Allocations
                        </button>
                    </Link>
                </div>
            </form>
        </div>
    )
}

export default LecturerHomepage